"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = void 0;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var clients = {
  dev: 'k5aG4M1VCe16wu1qFGaPe7lqt23PYysk',
  stg: 'oAWZakeaP56R8wJIEpEKIkjuPWAbEMnz',
  prod: 'JWT9GBjMcaJ7dn8FCzZ7SVESpgYj98nq',
  tools: null // needs to be passed in for the correct tool

};
var domains = {
  dev: 'd.onelog.ch',
  stg: 's.onelog.ch',
  prod: 'onelog.ch'
};

var getRingierConnectConfig = function getRingierConnectConfig(env) {
  return {
    domain: "login.".concat(domains[env]),
    // auth0 domain
    audience: "https://api.".concat(domains[env], "/profile/v1"),
    // auth0 audience
    issuer: "https://login.".concat(domains[env], "/"),
    // auth0 token issuer
    userinfoApi: "https://login.".concat(domains[env], "/userinfo"),
    // api for fetching basic user information
    metadataApi: "https://api.".concat(domains[env], "/api/v2"),
    // api for fetching ringier connect metadata
    profile: "https://profile.".concat(domains[env]),
    // url of the page to edit the profile
    scope: 'openid email' // token scope

  };
};

var getToolsConfig = function getToolsConfig() {
  return {
    domain: "energych.eu.auth0.com",
    // auth0 domain
    audience: 'https://energych.eu.auth0.com/api/v2/',
    // auth0 audience
    issuer: "https://energych.eu.auth0.com/",
    // auth0 token issuer
    userinfoApi: "https://energych.eu.auth0.com/userinfo",
    // api for fetching basic user information
    metadataApi: "https://not-available-within-tools-env",
    // api for fetching ringier connect metadata
    profile: "https://not-available-within-tools-env",
    // url of the page to edit the profile
    scope: 'openid email profile' // token scope

  };
};

var getConfig = function getConfig(env) {
  var baseConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread({
    env: env,
    clientId: clients[env],
    // auth0 client id
    responseType: 'token id_token',
    // auth0 response type
    loginRedirect: '/auth/callback',
    // page in your application where the auth0 login params should get parsed
    logoutRedirect: '/',
    // page in your application where the user should land after a logout
    renewTokenTimeout: 20 * 1000,
    // timeout until a refresh token request will be handled as failed
    brand: 'energy',
    // auth brand, defaults to energy
    // 'used': a new token will get requested when it is about to expire (<1h) but only when a method
    //         which uses it (.isLoggedIn(), .getUser() or .getMetadata()) is called.
    // 'auto': a new token will get reqeusted as soon as it is about to expire (<1h)
    //         using a clientside interval.
    tokenRenewMode: 'auto'
  }, env === 'tools' ? getToolsConfig() : getRingierConnectConfig(env), {
    log: env === 'dev' || env === 'stg'
  }, baseConfig);
};

exports.getConfig = getConfig;